<template>
  <div class="web-not-found">
    <div class="web-main">
      <img class="heading" src="../assets/images/common/notfound.png" alt="">
      <div class="eye-container">
        <div class="eyes">
          <div class="pupils"></div>
        </div>
        <div class="eyes">
          <div class="pupils"></div>
        </div>
      </div>
      <div class="error-container">
        <h2>WHO TURNED OFF THE LIGHT?</h2>
        <h4 class="error" @click="routerLink('/home')">回到首页</h4>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
    data() {
      return {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .web-not-found {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #FFFFFF;
    background-color: black;
  }

  .heading {
    width: 508px;
    height: 112px;
    margin: 0 auto;
  }

  .eye-container {
    display: flex;
    justify-content: center;
    margin-bottom: 5%;
  }

  .eyes {
    width: 5em;
    height: 5em;
    border-radius: 50%;
    background-color: white;
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    animation: blinking 3s ease-out 2 5s;
  }

  .pupils {
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: absolute;
    background-color: black;
    animation: moving-pups 2.5s cubic-bezier(.43, -0.45, .45, 1.42) infinite;
  }

  .error-container {
    text-align: center;
  }

  .error {
    display: inline-block;
    padding: 5px 15px;
    border: 2px solid #FFFFFF;
    border-radius: 4px;
    margin-top: 20px;
    cursor: pointer;
  }

  @keyframes moving-pups {
    0% {
      left: 14%;
    }

    50% {
      left: 70%;
    }

    100% {
      left: 14%;
    }
  }

  @keyframes blinking {
    0% {
      transform: rotateX(0deg);
    }

    20% {
      transform: rotateX(90deg);
    }

    60% {
      transform: rotateX(45deg);
    }

    70% {
      transform: rotateX(30deg);
    }

    80% {
      transform: rotateX(0deg);
    }

    100% {
      transform: rotateX(0deg);
    }
  }

  @media screen and (max-width: 800px) {
    .heading {
      width: 80vw;
      height: auto;
    }

    .eyes {
      width: 3em;
      height: 3em;
      margin: 15px;
    }

    .error-container h2 {
      font-size: 4vw;
    }

    .error {
      padding: 3px 12px;
      margin-top: 15px;
      font-size: 4vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NotFoundComponent.vue